import { ReportApiEndpoints } from '@contracts';

export const REPORT_ENDPOINT: ReportApiEndpoints = {
  list: {
    path: 'get/report',
    domain: 'core',
    version: 'v1',
  },
  exportSummary: {
    path: 'report/export',
    domain: 'fast',
    version: 'v1',
  },
  exportCustom: {
    path: 'report/custom-export',
    domain: 'fast',
    version: 'v1',
  },
};
